import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';

import { CustomerExportOptionParams } from '@/sections/customerManagement/types';
import type { DropdownOption } from '@/types/dropdown.types';

/**
 * Builds export action dropdown options
 *
 * Provides options for exporting customer data.
 *
 * @param params - Parameters for building export options
 * @returns Array of dropdown options for export actions
 */
export const getCustomerExportOptions = ({
  customers,
  handlers,
}: CustomerExportOptionParams): DropdownOption[] => {
  const hasCustomers = customers.length > 0;

  return [
    {
      label: 'Export as CSV',
      icon: <DocumentArrowDownIcon className="size-5" />,
      onClick: () => handlers.handleExport(customers, 'csv'),
      disabled: !hasCustomers,
    },
    {
      label: 'Export as JSON',
      icon: <DocumentArrowDownIcon className="size-5" />,
      onClick: () => handlers.handleExport(customers, 'json'),
      disabled: !hasCustomers,
    },
  ];
};
